<div class="container">
  <div class="wide">
    <lib-machine-picker
      [items]="state.machines$"
      [showAllEntry]="true"
      [preselectedItem]="null"
      (selectedItemChanged)="machineChanged($event)"
    ></lib-machine-picker>
  </div>
  <div class="wide">
    <lib-construction-site-picker
      [conSites]="state.conSites$"
      [showAllEntry]="true"
      (selectedConSiteChanged)="conSiteChanged($event)"
    ></lib-construction-site-picker>
  </div>
  <div class="wide">
    <lib-month-picker
      [showAllEntry]="true"
      (selectedValueChanged)="monthChanged($event)"
      (selectedYearChanged)="yearChanged($event)"
    ></lib-month-picker>
  </div>

  <div class="custom-table">
    <div class="row header">
      <div class="col">Datum</div>
      <div class="col grow">Maschine</div>
      <div class="col">Nutzung</div>
    </div>

    @for (usage of filteredEntries; track usage) {
    <div class="row">
      <div class="col">{{ toolService.formatDt(usage.date) }}</div>
      <div class="col grow">
        {{ usage.name ?? (state.getMachineNameAsync(usage.id) | async) }}
      </div>
      <div class="col">{{ usage.usageInHours }} h</div>
    </div>
    } @if(filteredEntries.length > 0){
    <div class="row footer">
      <div class="col"></div>
      <div class="col grow"></div>
      <div class="col">Summe {{ getTotalHours() }} h</div>
    </div>
    }
  </div>

  @if(filteredEntries.length == 0){
  <div class="empty">{{ "machinery.noUsage" | translate }}</div>
  }
</div>
